import { StarFilled } from "@ant-design/icons"
import { Col, Empty, Pagination, Row } from "antd"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { allProducts } from "../data/productsData"
import { CardContainer, CardProduct, CardStyled } from "../styled"

const CardItem = ({ filters, products = [] }) => {
  const [filteredProducts, setFilteredProducts] = useState([])
  const [pagination, setPagination] = useState({
    CurrentPage: 1,
    PageSize: 16,
  })
  const [dataPost, setDataPost] = useState({
    total: 0,
    data: [],
  })
  const navigate = useNavigate()
  useEffect(() => {
    applyFilters()
  }, [filters, pagination])

  const applyFilters = () => {
    let filtered = products.length
      ? allProducts.filter(p => products.includes(p.id))
      : allProducts

    // productType filter
    if (filters.productTypeId) {
      filtered = filtered.filter(p => p.productTypeId === filters.productTypeId)
    }

    //category filter
    if (filters.categories.length) {
      filtered = filtered.filter(p => filters.categories.includes(p.categoryId))
    }

    //price filter
    filtered = filtered.filter(
      p => p.price >= filters.priceRange[0] && p.price <= filters.priceRange[1],
    )

    //sorting
    const sortBy = filters.sortBy || "newest"
    switch (sortBy) {
      case "best-seller":
        filtered.sort((a, b) => b.sold - a.sold)
        break
      case "newest":
        filtered.sort((a, b) => b.id - a.id)
        break
      case "price-low-high":
        filtered.sort((a, b) => a.price - b.price)
        break
      case "price-high-low":
        filtered.sort((a, b) => b.price - a.price)
        break
      default:
        break
    }

    setFilteredProducts(filtered)

    //Pagination
    const startIndex = (pagination.CurrentPage - 1) * pagination.PageSize
    const endIndex = startIndex + pagination.PageSize
    setDataPost({
      total: filtered.length,
      data: filtered.slice(startIndex, endIndex),
    })
  }
  return (
    <CardProduct>
      {dataPost.data.length ? (
        <Row>
          <CardContainer>
            {dataPost.data.map(product => {
              // Tính toán rating trung bình
              const averageRating = product.reviews.length
                ? product.reviews.reduce(
                    (sum, review) => sum + review.rating,
                    0,
                  ) / product.reviews.length
                : 0

              return (
                <Col
                  xs={12}
                  sm={12}
                  md={8}
                  lg={6}
                  key={`/san-pham/${product.id}`}
                >
                  <CardStyled
                    hoverable
                    onClick={() =>
                      navigate(`/chi-tiet-giai-phap/${product.id}`)
                    }
                  >
                    <img
                      className="card-image"
                      src={product.images?.[0] || ""}
                      alt={product.title}
                    />
                    <div className="card-content">
                      <h3 className="card-title max-line1">{product.title}</h3>
                      <p className="card-description max-line1">
                        {product.description}
                      </p>

                      <div className="card-footer">
                        <div className="card-rating">
                          {[...Array(5)].map((_, i) => (
                            <StarFilled
                              key={i}
                              style={{ color: "#FFD700", marginRight: 4 }}
                            />
                          ))}
                        </div>
                        <span className="card-sold">Đã bán {product.sold}</span>
                      </div>
                      <span className="card-price">
                        {product.price === 0
                          ? "Liên hệ"
                          : (
                              product.price *
                              (1 - product.sale / 100)
                            ).toLocaleString("vi-VN") + " đ"}
                      </span>
                    </div>
                  </CardStyled>
                </Col>
              )
            })}
          </CardContainer>
        </Row>
      ) : (
        <div
          className="d-flex-center"
          style={{
            height: "30vh",
            width: "100%",
          }}
        >
          <Empty description="Sản phẩm chưa kịp cập nhật. Vui lòng quay lại sau" />
        </div>
      )}

      <div
        className="d-flex justify-content-flex-end"
        style={{ marginTop: "16px" }}
      >
        <Pagination
          className="d-flex"
          total={dataPost.total}
          current={pagination.CurrentPage}
          pageSize={pagination.PageSize}
          responsive
          locale={{ items_per_page: "" }}
          showSizeChanger={true}
          pageSizeOptions={["16", "32", "64", "80"]}
          onChange={(CurrentPage, PageSize) =>
            setPagination({ CurrentPage, PageSize })
          }
        />
      </div>
    </CardProduct>
  )
}

export default CardItem
